module.exports = __webpack_public_path__ + "img/3.e11ccc65.jpg";